import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { createGlobalStyle } from 'styled-components'

export const FormCard = styled.div`
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow:
    0px 1px 2px 0px var(--shadow-smooth),
    0px 2px 4px 0px var(--shadow-smooth);

  @media screen and (max-width: 768px) {
    padding: 1.25rem 1rem;
  }
`

export const FormCardTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem;
`

export const FormCardDescription = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-secondary);
  margin: 0 0 1.5rem;
  line-height: 1.5;
`

export const SelectedRoomsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
`

export const SelectedRoomChip = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;
  flex: 0 0 256px;
  width: 256px;
  height: 100px;
  max-width: 100%;
  background: var(--background);
  border-radius: 10px;
  padding: 1rem 1.25rem;
  box-sizing: border-box;
  box-shadow: 0px var(--Elevation2OffsetY, 2px) var(--Elevation2Radius, 8px) 0px var(--shadow-smooth);

  @media screen and (max-width: 576px) {
    flex: 1 1 100%;
    width: 100%;
  }
`

export const SelectedRoomName = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.3;
`

export const SelectedRoomCapacity = styled.span`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--grey-lighter);
  line-height: 1.4;
`

export const CapacityIcon = styled(FontAwesomeIcon)`
  font-size: 0.875rem;
  color: var(--orange-medium);
`

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--border);
  margin: 0 0 1.5rem;
`

export const SectionLabel = styled.h3`
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 1.25rem;
`

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.25rem;

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

export const FieldFull = styled.div`
  grid-column: 1 / -1;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--grey);
  line-height: 140%;
  margin: 0;
`

export const RequiredMark = styled.span`
  color: var(--red);
  margin-left: 2px;
`

export const FieldError = styled.span`
  font-size: 0.8rem;
  color: var(--red);
  margin-top: 2px;
`

export const DateTimeRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.25rem;
  margin-top: 1rem;

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`

export const RangeAttentionBanner = styled.p`
  margin: 0.75rem 0 0;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 1px solid var(--yellow);
  background: var(--yellow-light);
  color: var(--grey);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.45;
`

export const AttendeesWrapper = styled.div`
  margin-top: 1rem;
`

export const QuestionDescription = styled.p`
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.4;
  margin: 0;
`

export const DynamicSection = styled.div`
  margin-top: 1.5rem;
`

export const UploadFileButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0.375rem 0.75rem;
  background: var(--secondary-p);
  border: 1px solid var(--secondary-p);
  color: var(--primary);
  font-size: 0.875rem;
  font-weight: 750;
  border-radius: 4px;
  margin-top: 0.25rem;

  &:hover,
  &:focus {
    background: var(--secondary-b);
    border-color: var(--primary);
    color: var(--white);
  }
`

export const CheckboxOptionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
`

export const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: var(--primary);
  cursor: pointer;
`

export const OptionLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
  cursor: pointer;
`

export const CheckboxInput = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  accent-color: var(--primary);
  cursor: pointer;
`

export const CheckboxText = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.5;
`

export const TermsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.25rem;
`

export const CheckboxRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  cursor: pointer;
  margin: 0;
`

export const TermsCheckboxContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  min-width: 0;
`

export const TermsNote = styled.p`
  font-size: 0.8125rem;
  font-weight: 400;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
`

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  min-height: 320px;
`

export const SuccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--green-light);
  margin-bottom: 1.5rem;
  font-size: 2rem;
  color: var(--compose-cyan);
`

export const SuccessTitle = styled.h2`
  font-size: 1.375rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
`

export const SuccessDescription = styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-secondary);
  margin: 0 0 2rem;
  max-width: 480px;
  line-height: 1.6;
`

export const SuccessButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.5rem;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background: var(--white);
  color: var(--primary);
  font-size: 0.9375rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: var(--primary);
    color: var(--white);
  }
`

export const ReservationDatePickerGlobalStyle = createGlobalStyle`
  .res-datepicker-popover .react-datepicker {
    font-family: inherit;
    border: none;
    width: 100%;
  }

  .res-datepicker-popover .react-datepicker__month-container {
    width: 100%;
    float: none;
  }

  .res-datepicker-popover .react-datepicker__header {
    background-color: var(--white);
    border-bottom: 1px solid #e8eaf0;
    padding: 12px 0 8px;
  }

  .res-datepicker-popover .react-datepicker__current-month {
    font-size: 15px;
    font-weight: 600;
    color: #1a2b4a;
    text-transform: capitalize;
    margin-bottom: 8px;
  }

  .res-datepicker-popover .react-datepicker__navigation {
    top: 14px;
  }

  .res-datepicker-popover .react-datepicker__navigation-icon::before {
    border-color: #1a6fc4;
    border-width: 2px 2px 0 0;
    width: 7px;
    height: 7px;
  }

  .res-datepicker-popover .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
    padding: 0 4px;
    margin-bottom: 0;
  }

  .res-datepicker-popover .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 500;
    color: #6b7a99;
    width: 36px;
    line-height: 28px;
    text-align: center;
    text-transform: capitalize;
  }

  .res-datepicker-popover .react-datepicker__week {
    display: flex;
    justify-content: space-between;
    padding: 0 4px;
  }

  .res-datepicker-popover .react-datepicker__month {
    margin: 6px 0;
  }

  .res-datepicker-popover .react-datepicker__day {
    width: 36px;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    color: #1a2b4a;
    border-radius: 50%;
    margin: 1px 0;
    position: relative;
  }

  .res-datepicker-popover .react-datepicker__day:hover {
    background-color: #e8f0fb;
    color: #1a6fc4;
    border-radius: 50%;
  }

  .res-datepicker-popover .react-datepicker__day--today {
    font-weight: 600;
    color: #1a6fc4;
    background-color: transparent;
    border: 1.5px solid #1a6fc4;
  }

  .res-datepicker-popover .react-datepicker__day--selected {
    background-color: #1a6fc4 !important;
    color: #fff !important;
    border-radius: 50% !important;
    font-weight: 500;
    border: none !important;
  }

  .res-datepicker-popover .react-datepicker__day--disabled {
    color: #c8cdd8;
    cursor: not-allowed;
    pointer-events: auto;
  }

  .res-datepicker-popover .react-datepicker__day--disabled:hover {
    background-color: transparent;
    color: #c8cdd8;
  }

  .res-datepicker-popover .react-datepicker__day.res-day-unavailable {
    color: #c8cdd8;
    cursor: not-allowed;
  }

  .res-datepicker-popover .react-datepicker__day.res-day-unavailable::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 4px;
    transform: translateX(-50%);
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--red);
  }

  .res-datepicker-popover .react-datepicker__day.res-day-unavailable .res-day-content {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .res-datepicker-popover .react-datepicker__day--outside-month {
    color: #b0b8cc;
  }

  .res-datepicker-popover .react-datepicker__time-container {
    width: 100%;
    border-left: none;
  }

  .res-datepicker-popover .react-datepicker__time-box {
    width: 100% !important;
  }

  .res-datepicker-popover .react-datepicker__time-list-item {
    font-size: 14px;
    color: #1a2b4a;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .res-datepicker-popover .react-datepicker__time-list-item:hover {
    background-color: #e8f0fb !important;
    color: #1a6fc4 !important;
  }

  .res-datepicker-popover .react-datepicker__time-list-item--selected {
    background-color: #1a6fc4 !important;
    color: #fff !important;
    font-weight: 500;
  }

  .res-datepicker-popover .react-datepicker__header--time {
    background-color: var(--white);
    border-bottom: 1px solid #e8eaf0;
    padding: 10px 0;
  }

  .res-datepicker-popover .react-datepicker-time__header {
    font-size: 14px;
    font-weight: 600;
    color: #1a2b4a;
  }

  .res-datepicker-popover .react-datepicker__navigation--previous {
    left: 16px;
  }

  .res-datepicker-popover .react-datepicker__navigation--next {
    right: 16px;
  }
`

export const PickerFieldContainer = styled.div`
  position: relative;
`

export const DatePickerTrigger = styled.button<{ $isInvalid?: boolean; $hasValue?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  height: 38px;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ $hasValue }) => ($hasValue ? 'var(--text-primary)' : 'var(--grey-lighter)')};
  background-color: var(--white);
  border: 1px solid ${({ $isInvalid }) => ($isInvalid ? 'var(--red)' : 'var(--border)')};
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    outline: none;
    border-color: ${({ $isInvalid }) => ($isInvalid ? 'var(--red)' : 'var(--primary)')};
    box-shadow: 0 0 0 0.2rem
      ${({ $isInvalid }) =>
        $isInvalid
          ? 'color-mix(in srgb, var(--red) 25%, transparent)'
          : 'var(--input-focus-shadow)'};
  }

  > span:first-of-type {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
`

export const DatePickerSvgIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--grey-lighter);
`

export const DatePickerPopover = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 1100;
  width: 296px;
  background: var(--white);
  border: 1px solid #dde3ef;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(26, 43, 74, 0.12);
  overflow: hidden;

  @media screen and (max-width: 576px) {
    width: min(296px, calc(100vw - 2rem));
    right: 0;
    left: auto;
  }
`

export const DatePickerCalendarWrapper = styled.div`
  padding: 4px 12px 8px;
`

export const PopoverInputFooter = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #eef0f6;
`

export const PopoverDateInput = styled.input`
  width: 100%;
  padding: 7px 36px 7px 12px;
  border: 1px solid #dde3ef;
  border-radius: 6px;
  font-size: 13px;
  color: #1a2b4a;
  background: #f8f9fc;
  outline: none;
  cursor: default;
  box-sizing: border-box;
`

export const PopoverInputIcon = styled.span`
  position: absolute;
  right: 26px;
  color: #6b7a99;
  display: flex;
  align-items: center;
  pointer-events: none;
`
